import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  Button
} from '@mui/material';
import {
  ArrowBack
} from '@mui/icons-material';

const TermsConditionsScreen = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box
      sx={{
        flexGrow: 1,
        backgroundColor: 'background.default',
        minHeight: '100vh',
        p: { xs: 1, sm: 2 },
        pb: { xs: 10, sm: 12 }
      }}
    >
      {/* Back Button */}
      <Box sx={{ mb: 2 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/')}
        >
          Back
        </Button>
      </Box>
      <Card
        sx={{
          maxWidth: 900,
          mx: 'auto',
          mt: 2
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 4 } }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              color: 'primary.main',
              textAlign: 'center',
              fontSize: { xs: '1.75rem', sm: '2.125rem' },
              mb: 4
            }}
          >
            Terms of Service
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              mb: 3,
              lineHeight: 1.7
            }}
          >
            The following terms and conditions apply to your use of this Website, including access to the Services (as defined below) and Content (as defined below) available through the Website. Please read these terms and conditions carefully before using the Website, accessing the Content and/or using the Services. By using the Website, the Services, or the Content, you are consenting to the terms and conditions in this terms of service agreement as they apply to you and your usage and access. Your use of the Website, the Services, or the Content is also subject to all applicable laws and regulations. If you do not agree to any of the terms of service in this agreement (the "TOS"), you should not use the Website, the Services, or the Content. Your use of the Website, the Content, and the Services is also governed by our Privacy Policy, which is available through a link on our homepage as well as most of the other pages on the Website.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            1. TERMS OF SERVICE
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            Bettor Advantage provides the Website, the Content, and the Services to you subject to the following Terms of Service ("TOS"). The TOS may be updated by us from time to time without notice to you. We suggest that from time to time you review the TOS for possible changes. In addition, when using any Services or accessing any Content, you will be subject to any posted guidelines or rules applicable to such Services or Content. All such additional guidelines or rules are hereby incorporated by reference into the TOS.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            2. SERVICES AND CONTENT
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
            Bettor Advantage currently provides users with various features and services, including statistical review, handicapper picks, and other interactive and non-interactive features, all of which may be updated, deleted, or otherwise modified from time to time at our discretion. In addition, Bettor Advantage provides access to certain photographs, text, images, statistics, logos, and other media and intellectual property related to or otherwise associated with Bettor Advantage. Unless stated otherwise, the Website, the Services, and the Content are subject to the TOS. You understand and agree that the Website, the Services, and the Content are provided "AS IS" and that Bettor Advantage assumes no responsibility in connection with your use of the Website, the Services, or the Content. The Website, the Services, and the Content are provided for your non-commercial entertainment and enjoyment. Under the TOS, you may download certain Content and Services available on the Website to a single personal computing device for your use and entertainment. However, you may not distribute, modify, republish, or publicly display any of the Content or Services unless you have the prior written permission of Bettor Advantage, which permission may be withheld at Bettor Advantage's sole discretion.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            The Service contains proprietary information, statistics, and projections, both original and from other third-party sources. Users of the Service may not engage in unauthorized spidering, "scraping," data mining or harvesting of Content, or use any other unauthorized automated means to gather data from or about the Service.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            3. ACCESS TO SERVICES
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            To use the Website or the Services or access the Content, you must obtain access to the World Wide Web and pay any service fees associated with such access. You must also provide all equipment necessary to make such connection to the World Wide Web, including a computer and modem or other access device.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            4. BACKGROUND INFORMATION
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            To use the Services, you may be required to register with Bettor Advantage by providing certain information about yourself, including your name and e-mail address. In consideration of your use of the Services, you agree to provide true, accurate, current and complete information about yourself as requested in connection with the provision of and/or registration for any of the Services, subject to all applicable laws. If you provide any information that is untrue, inaccurate, not current, or incomplete, or Bettor Advantage has reasonable grounds to suspect that such information is untrue, inaccurate, not current, or incomplete, Bettor Advantage has the right to suspend or terminate your password and/or refuse any and all current or future use of the Services.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            5. ACCESS BY MINORS
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7, fontWeight: 'bold', color: 'warning.main' }}>
            Persons under the age of 21 are prohibited from registering on Bettor Advantage.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            6. PRIVACY POLICY
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            All information collected about you during registration for use of the Services will be used in accordance with our Privacy Policy and all applicable laws.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            7. MEMBER PASSWORD AND SECURITY
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            You will receive (or set) a password upon completing the registration process for use of the Services. You are responsible for maintaining the confidentiality of the password and are fully responsible for all activities that occur under your password. You agree not to share your account with any other individuals and to immediately notify Bettor Advantage of any unauthorized use of your password or account or any other breach of security at signup@bettoradvantage.com. Bettor Advantage cannot and will not be liable for any loss or damage arising from your failure to comply with this Section 7.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            8. MEMBER CONDUCT
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
            You agree that in connection with your use of the Website, the Services, and the Content you will not:
          </Typography>
          <Box sx={{ ml: 2, mb: 3 }}>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              a. upload, post, email or otherwise transmit any content that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of anyone's privacy, hateful, or racially, ethnically or otherwise objectionable;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              b. harm or attempt to harm minors in any way;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              c. impersonate any person or entity or falsely state or otherwise misrepresent your affiliation with a person or entity;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              d. upload, post, email or otherwise transmit any content that you do not have a right to transmit under any law or under contractual or fiduciary relationships;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              e. upload, post, email or otherwise transmit any content that infringes any patent, trademark, trade secret, copyright or other intellectual property right of any party;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              f. upload, post, email or otherwise transmit any unsolicited or unauthorized advertising, promotional materials, "junk mail," "spam," "chain letters," "pyramid schemes," or any other form of solicitation;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              g. upload, post, email or otherwise transmit any material that contains software viruses or any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              h. interfere with or disrupt the Website, the Services, the Content or servers or networks connected to the Website, the Services or the Content;
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              i. intentionally or unintentionally violate any applicable local, state, national or international law.
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            9. USER MESSAGES
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
            <strong>a.</strong> With respect to any messages, information, data, graphics, photographs, images, creative ideas, concepts, know-how, techniques, suggestions or improvements or other content that you transmit, submit, post or upload to the Website and/or in connection with any of the Services (each, a "Message"), you are, by transmitting or uploading such Message, granting Bettor Advantage a perpetual, royalty-free, sub-licensable, non-exclusive, worldwide and irrevocable right and license to use, reproduce, modify, publish, translate, prepare derivative works based upon, and distribute such Message for any purpose and in any form.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
            <strong>b.</strong> When any user posts any Message to the Website or any of the Services, Bettor Advantage shall have the right, but not the obligation, to review, edit or delete any Message for any reason, at Bettor Advantage's sole discretion.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            <strong>c.</strong> You acknowledge and agree that Bettor Advantage may preserve Messages and may also disclose Messages if required to do so by law or in the good-faith belief that such preservation or disclosure is reasonably necessary.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            10. VOTING
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            Bettor Advantage may offer you the opportunity to vote in connection with certain events. By casting your vote, you are agreeing to abide by the TOS and any and all voting guidelines posted on the Website.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            11. INDEMNITY
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            You agree to indemnify, defend and hold harmless Bettor Advantage, the directors, governors, owners, other officials, partners, partnerships, principals, employees, affiliates and other related entities, servants, agents, representatives, successors and assigns from and against any claim or demand, including reasonable attorneys' fees, arising out of Messages you post to, submit or transmit through the Website or the Services, your use of the Website or the Services, your connection to the Website or the Services, your violation of the TOS, or your violation of any rights of another.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            12. MODIFICATIONS TO WEBSITE, INCLUDING THE SERVICES
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            Bettor Advantage reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, the Website or Services (or any part thereof) with or without notice.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            13. TERMINATION
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            You agree that Bettor Advantage, in its sole discretion, may terminate your password or use of the Website and/or the Services, and remove and discard any Message within the Services, for any reason, including, without limitation, for lack of use or if Bettor Advantage believes that you have violated or acted inconsistently with the letter or spirit of the TOS.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            14. BETTOR ADVANTAGE ADVERTISERS AND VENDORS
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            Your correspondence or business dealings with, or participation in promotions of, advertisers and vendors found on or through the Services or the Website, including payment and delivery of related goods or services, and any other terms, conditions, warranties or representations associated with such dealings, are solely between you and such advertiser and/or vendor.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            15. LINKING
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            The Website and/or Services may provide, or third parties may provide, links to other World Wide Web sites or resources. Because Bettor Advantage has no control over such sites and resources, you acknowledge and agree that Bettor Advantage is not responsible for the availability of such external sites or resources, and does not endorse and is not responsible or liable for any content, advertising, products, or other materials on or available from such sites or resources.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            16. PROPRIETARY RIGHTS
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            Services and Content are the property of Bettor Advantage and are licensed to Bettor Advantage and may not be reproduced without the prior written consent of Bettor Advantage. You further acknowledge and agree that any necessary software used in connection with the Website, the Services, and the Content contains proprietary and confidential information that is protected by applicable intellectual property and other laws.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            17. DISCLAIMER OF WARRANTIES
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, fontWeight: 'bold' }}>
            YOU EXPRESSLY UNDERSTAND AND AGREE THAT:
          </Typography>
          <Box sx={{ ml: 2, mb: 3 }}>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              a. YOUR USE OF THE WEBSITE, THE SERVICES AND THE CONTENT IS AT YOUR SOLE RISK. THE WEBSITE, THE SERVICES AND THE CONTENT ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              b. BETTOR ADVANTAGE MAKES NO WARRANTY THAT THE WEBSITE, SERVICES OR THE CONTENT WILL MEET YOUR REQUIREMENTS, WILL BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              c. ANY MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE WEBSITE OR THE SERVICES IS DONE AT YOUR OWN DISCRETION AND RISK.
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.6 }}>
              d. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM THE WEBSITE OR THROUGH OR FROM THE SERVICES OR THE CONTENT SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THE TOS.
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            18. LIMITATION OF LIABILITY
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7, fontWeight: 'bold' }}>
            YOU EXPRESSLY UNDERSTAND AND AGREE THAT BETTOR ADVANTAGE SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR USE OF THE WEBSITE, THE SERVICES, OR THE CONTENT.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            19. EXCLUSIONS AND LIMITATIONS
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS OF SECTIONS 17 AND 18 MAY NOT APPLY TO YOU.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            20. NOTICE
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            Notices to you may be made via either email or regular mail. The Website may also provide notices of changes to the TOS or other matters by displaying notices or links to notices to you generally on the Services.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            21. LINKING TO THE WEBSITE
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            No link to the Website may be "framed" to the extent such frame contains any sponsorship, advertising, or other commercial text or graphics.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main', mt: 3, mb: 2 }}>
            22. GENERAL PROVISIONS
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
            The TOS constitute the entire agreement between you and Bettor Advantage and govern your use of the Website, the Services, and access to the Content, superseding any prior agreements between you and Bettor Advantage. The Website is created and controlled by Bettor Advantage in the State of Florida. As such, the laws of the State of Florida will govern these disclaimers, terms and conditions, without giving effect to any principles of conflicts of laws. You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to use of the Services or the TOS must be filed within one (1) year after such claim or cause of action arose or be forever barred.
          </Typography>

          <Divider sx={{ my: 3 }} />
          
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              textAlign: 'center',
              fontStyle: 'italic'
            }}
          >
            Last Updated: {new Date().toLocaleDateString()}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TermsConditionsScreen;